module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "md-icon": "home",
      "md-label": "Dashboard"
    }
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('date-range-picker', {
    staticClass: "pull-right",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    staticStyle: {
      "margin-right": "5px",
      "margin-top": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewAssignment('0', '1', '1', 'clear')
      }
    }
  }, [_vm._v("Clear")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Clients")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers Executed\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsRefuel,
      "series": _vm.seriesRefuel
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Import Destination")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 text-muted"
  }, [_vm._v("\n                    By No. of Containers\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart2"
    }
  }, [(_vm.showGraph == true) ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "350",
      "options": _vm.chartOptionsExDesti,
      "series": _vm.seriesExDesti
    }
  }) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "md-icon": "content_paste",
      "md-label": "Reports"
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n                Filters")]), _vm._v(" "), (_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.getReports
    }
  }, [_vm._v("Export as Excel")]) : _vm._e()], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', {
    staticClass: "mt-2"
  }, [_c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "40",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "40",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1');
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n                  ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleBookingForm,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "ffImportId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "importerName",
      fn: function(row11) {
        return [_c('span', [_vm._v("Importer : " + _vm._s(row11.item.importerName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Exporter : " + _vm._s(row11.item.exporterName)), _c('br')])]
      }
    }, {
      key: "ffImportSeries",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.ffImportSeries)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(row1.item.loginTime))), _c('br')])]
      }
    }, {
      key: "placeOfReceipt",
      fn: function(row21) {
        return [_c('b', [_vm._v("Type : " + _vm._s(row21.item.transportType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Stuffing Type : " + _vm._s(row21.item.stuffingType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Shipping Line : " + _vm._s(row21.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR Location : " + _vm._s(row21.item.placeOfReceipt))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Load Port Location : " + _vm._s(row21.item.loadPort))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD Location : " + _vm._s(row21.item.portOfDischarge))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row21.item.finalPlaceDelivery))])]
      }
    }, {
      key: "ContainerNo",
      fn: function(row3) {
        return [(row3.item.ContainerNo != null) ? _c('div', _vm._l((row3.item.ContainerNo.split(',')), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item + " "))])], 1)])
        })) : _vm._e()]
      }
    }, {
      key: "containerTypeName",
      fn: function(row2) {
        return [(row2.item.containerTypeName != null) ? _c('div', _vm._l((row2.item.containerTypeName.split(',')), function(item1, index) {
          return _c('div', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 + " "))])], 1)
        })) : _vm._e()]
      }
    }, {
      key: "shippingBillNo",
      fn: function(row5) {
        return [(row5.item.shippingBillNo != null) ? _c('div', _vm._l((row5.item.shippingBillNo.split(',')), function(item1, index) {
          return _c('div', {
            key: index
          }, [_c('span', [_vm._v(" " + _vm._s(item1))])])
        })) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13419fc1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/freightImportReports.vue
// module id = 2406
// module chunks = 0